import { render, staticRenderFns } from "./LayoutDefaultBlock.vue?vue&type=template&id=977c977c&"
import script from "./LayoutDefaultBlock.vue?vue&type=script&lang=ts&"
export * from "./LayoutDefaultBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports